import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ContactCompanyRequest,
  ContactCompanyResponse
} from '../models/empresa.model';

@Injectable({
  providedIn: 'root'
})
export class ContactCompanyApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // POST /api/contact-companies - Create association
  createAssociation(request: ContactCompanyRequest): Observable<ContactCompanyResponse> {
    return this.http.post<ContactCompanyResponse>(`${this.apiUrl}/contact-companies`, request);
  }

  // GET /api/contact-companies/{id} - Get by ID
  getById(id: number, businessId: number): Observable<ContactCompanyResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactCompanyResponse>(`${this.apiUrl}/contact-companies/${id}`, { params });
  }

  // PUT /api/contact-companies/{id} - Update association
  updateAssociation(id: number, request: ContactCompanyRequest, businessId: number): Observable<ContactCompanyResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.put<ContactCompanyResponse>(`${this.apiUrl}/contact-companies/${id}`, request, { params });
  }

  // DELETE /api/contact-companies/{id} - Delete association
  deleteAssociation(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/contact-companies/${id}`, { params });
  }

  // POST /api/contact-companies/{id}/set-primary - Set as primary
  setPrimary(id: number, businessId: number): Observable<ContactCompanyResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<ContactCompanyResponse>(`${this.apiUrl}/contact-companies/${id}/set-primary`, {}, { params });
  }

  // GET /api/contact-companies/by-contact/{idContact} - All companies for a contact
  getByContact(idContact: number, businessId: number): Observable<ContactCompanyResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactCompanyResponse[]>(`${this.apiUrl}/contact-companies/by-contact/${idContact}`, { params });
  }

  // GET /api/contact-companies/by-company/{idCompany} - All contacts for a company
  getByCompany(idCompany: number, businessId: number): Observable<ContactCompanyResponse[]> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<ContactCompanyResponse[]>(`${this.apiUrl}/contact-companies/by-company/${idCompany}`, { params });
  }

}
